import { render, staticRenderFns } from "./pdfPlanos.vue?vue&type=template&id=0ed2cfdc"
import script from "./pdfPlanos.vue?vue&type=script&lang=js"
export * from "./pdfPlanos.vue?vue&type=script&lang=js"
import style0 from "./pdfPlanos.vue?vue&type=style&index=0&id=0ed2cfdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports